import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "axios";
import toast from "react-hot-toast";
import uploadImg from "./ReuseableImgUploadFuctions/uploadImg";
import { State, City } from "country-state-city";
import Select from "react-select";

function AddStaffForm({ loadStaffForm, setLoadStaffForm }) {
  const [load, setLoad] = useState(false);
  const [allStates, setAllStates] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [selectedState, setSelectedState] = useState();
  const [selectedCity, setSelectedCity] = useState();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm();

  //Fetching all states of India
  useEffect(() => {
    const states = State.getStatesOfCountry("IN"); //IN is the country code for India
    console.log("States: ", states);
    const formattedStates = states.map((state) => ({
      value: state?.isoCode,
      label: state?.name,
    }));

    setAllStates(formattedStates);
  }, []);

  //Fetch cities when state is selected
  useEffect(() => {
    if (selectedState) {
      console.log("Selected State: ", selectedState);
      const cities = City.getCitiesOfState("IN", selectedState?.value);
      const formattedCities = cities.map((city) => ({
        value: city?.name,
        label: city?.name,
      }));
      setAllCities(formattedCities);
    } else {
      setAllCities([]);
    }
  }, [selectedState]);

  console.log("States: ", allStates);

  const onSubmit = async (data) => {
    setLoad(true);
    try {
      // Upload profile picture
      const profilePicUrl = data.profilePic?.[0]
        ? await uploadImg(data.profilePic[0])
        : null;

      // Upload Aadhaar front
      const aadhaarFrontUrl = data.adhaarFrontPic?.[0]
        ? await uploadImg(data.adhaarFrontPic[0])
        : null;

      // Upload Aadhaar back
      const aadhaarBackUrl = data.adhaarBackPic?.[0]
        ? await uploadImg(data.adhaarBackPic[0])
        : null;

      // Create final form data object with image URLs
      const finalData = {
        ...data,
        profilePic: profilePicUrl,
        adhaarFrontPic: aadhaarFrontUrl,
        adhaarBackPic: aadhaarBackUrl,
      };

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/users/user-register`,
        headers: {
          "Content-Type": "application/json",
        },
        data: finalData,
      };

      axios
        .request(config)
        .then((response) => {
          setLoadStaffForm(false);
          reset();
          setLoadStaffForm(false);
          console.log(response.data);
          setLoad(false);

          toast.success("Staff Added .");
        })
        .catch((error) => {
          console.log(error);
          toast.error(error.response.data.message);
          setLoad(false);
        });

      console.log("Final Data to Submit:", finalData);
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form, please try again.");
    }
  };

  return (
    <div className="flex bg-black/50 backdrop-blur-sm fixed inset-0 z-50 items-center justify-center min-h-screen  p-4">
      <div className="bg-white h-[30rem] md:h-[35rem] overflow-auto relative rounded-lg shadow-lg p-8 lg:py-8 lg:px-16 w-full max-w-5xl">
        <div className="mb-6">
          <h2 className="text-2xl font-semibold text-center">Add Staff</h2>
          <AiFillCloseCircle
            onClick={() => setLoadStaffForm(false)}
            className="cursor-pointer text-primaryColor absolute top-4 right-4"
            size={30}
          />
        </div>

        <form className="" onSubmit={handleSubmit(onSubmit)}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                {...register("name", { required: "Name is required" })}
                type="text"
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.name ? "border-red-500" : "focus:border-blue-300"
                }`}
                placeholder="Enter name"
              />
              {errors.name && (
                <p className="text-red-500 text-xs">{errors.name.message}</p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Mob Number <span className="text-red-500">*</span>
              </label>
              <input
                {...register("phoneNumber", {
                  required: "Mobile Number number is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Mobile number must be 10 digits",
                  },
                })}
                type="number"
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10);
                }}
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.phoneNumber
                    ? "border-red-500"
                    : "focus:border-blue-300"
                }`}
                placeholder="Enter Mobile Number"
              />
              {errors.phoneNumber && (
                <p className="text-red-500 text-xs">
                  {errors.phoneNumber.message}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Email ID <span className="text-red-500">*</span>
              </label>
              <input
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Enter a valid email",
                  },
                })}
                type="email"
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.email ? "border-red-500" : "focus:border-blue-300"
                }`}
                placeholder="Enter email"
              />
              {errors.email && (
                <p className="text-red-500 text-xs">{errors.email.message}</p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                UserType <span className="text-red-500">*</span>
              </label>
              <select
                {...register("userType", { required: "UserType is required" })}
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.userType ? "border-red-500" : "focus:border-blue-300"
                }`}
              >
                <option value="">Select UserType</option>
                <option value="subAdmin">SubAdmin</option>
                <option value="manager">Manager</option>
              </select>
              {errors.userType && (
                <p className="text-red-500 text-xs">
                  {errors.userType.message}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Adhaar Number <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 12); // Replace non-numeric characters
                }}
                {...register("adhaarNumber", {
                  required: "Aadhaar is required",
                })}
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.adhaarNumber
                    ? "border-red-500"
                    : "focus:border-blue-300"
                }`}
                placeholder="Enter your Aadhaar Number"
              />

              {errors.adhaarNumber && (
                <p className="text-red-500 text-xs">
                  {errors.adhaarNumber.message}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Joining Date <span className="text-red-500">*</span>
              </label>
              <input
                {...register("joiningDate", {
                  required: "Date of birth is required",
                })}
                type="date"
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.joiningDate
                    ? "border-red-500"
                    : "focus:border-blue-300"
                }`}
              />
              {errors.joiningDate && (
                <p className="text-red-500 text-xs">
                  {errors.joiningDate.message}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Password <span className="text-red-500">*</span>
              </label>
              <input
                {...register("password", { required: "Password is required" })}
                type="password"
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.password ? "border-red-500" : "focus:border-blue-300"
                }`}
                placeholder="Enter password"
              />
              {errors.password && (
                <p className="text-red-500 text-xs">
                  {errors.password.message}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Date of Birth <span className="text-red-500">*</span>
              </label>
              <input
                {...register("dateOfBirth", {
                  required: "Date of birth is required",
                })}
                type="date"
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.dateOfBirth
                    ? "border-red-500"
                    : "focus:border-blue-300"
                }`}
              />
              {errors.dateOfBirth && (
                <p className="text-red-500 text-xs">
                  {errors.dateOfBirth.message}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">Gender</label>
              <select
                {...register("gender", { required: "Gender is required" })}
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.gender ? "border-red-500" : "focus:border-blue-300"
                }`}
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
              {errors.gender && (
                <p className="text-red-500 text-xs">{errors.gender.message}</p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Address <span className="text-red-500">*</span>
              </label>
              <input
                {...register("address", { required: "Address is required" })}
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.address ? "border-red-500" : "focus:border-blue-300"
                }`}
                placeholder="Enter address"
              />
              {errors.address && (
                <p className="text-red-500 text-xs">{errors.address.message}</p>
              )}
            </div>
            {/* State */}
            <div>
              <label
                htmlFor="state"
                className="text-sm font-medium text-primaryTextColor"
              >
                State *
              </label>
              <Select
                options={allStates}
                onChange={(option) => {
                  console.log("option", option);
                  setSelectedState(option);
                  setValue("state", option.label);
                }}
                required
                placeholder="Select State"
                className={`border ${
                  errors.state ? "border-red-500" : "border-gray-300"
                } rounded w-full`}
              />
              {errors.state && (
                <span className="text-red-500 text-sm">
                  {errors.state.message}
                </span>
              )}
            </div>

            {/* City */}

            <div>
              <label
                htmlFor="city"
                className="text-sm font-medium text-primaryTextColor"
              >
                City *
              </label>

              <Select
                options={allCities}
                value={selectedCity}
                onChange={(option) => {
                  console.log("option in City: ", option);
                  setValue("city", option.value);
                }}
                required
                placeholder="Select your City"
                className={`border ${
                  errors.city ? "border-red-500" : "border-gray-300"
                } rounded w-full`}
              />
              {errors.city && (
                <span className="text-red-500 text-sm">
                  {errors.city.message}
                </span>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Nationality <span className="text-red-500">*</span>
              </label>
              <input
                {...register("nationality", {
                  required: "Nationality is required",
                })}
                type="text"
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.nationality
                    ? "border-red-500"
                    : "focus:border-blue-300"
                }`}
                placeholder="Enter nationality"
              />
              {errors.nationality && (
                <p className="text-red-500 text-xs">
                  {errors.nationality.message}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Profile Pic <span className="text-red-500">*</span>
              </label>
              <input
                {...register("profilePic", {
                  required: "Profile Pic is required",
                })}
                type="file"
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.profilePic ? "border-red-500" : "focus:border-blue-300"
                }`}
              />
              {errors.profilePic && (
                <p className="text-red-500 text-xs">
                  {errors.profilePic.message}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Aadhaar Card Front Img <span className="text-red-500">*</span>
              </label>
              <input
                {...register("adhaarFrontPic", {
                  required: "Aadhaar Front Image is required",
                })}
                type="file"
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.adhaarFrontPic
                    ? "border-red-500"
                    : "focus:border-blue-300"
                }`}
              />
              {errors.adhaarFrontPic && (
                <p className="text-red-500 text-xs">
                  {errors.adhaarFrontPic.message}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Aadhaar Card Back Img <span className="text-red-500">*</span>
              </label>
              <input
                {...register("adhaarBackPic", {
                  required: "Aadhaar Back Image is required",
                })}
                type="file"
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.adhaarBackPic
                    ? "border-red-500"
                    : "focus:border-blue-300"
                }`}
              />
              {errors.adhaarBackPic && (
                <p className="text-red-500 text-xs">
                  {errors.adhaarBackPic.message}
                </p>
              )}
            </div>
          </div>

          <div className="flex justify-between mt-6 gap-6">
            <button
              type="button"
              onClick={() => setLoadStaffForm(false)}
              className="bg-white w-[50%] border hover:bg-secondaryTextColor px-4 py-2 rounded-md"
            >
              Cancel
            </button>
            <button
              className="tracking-wide w-[50%] bg-primaryBtnColor text-white py-2 px-4 rounded-lg hover:bg-primaryBtnHoverColor"
              type="submit"
            >
              {"Submit"}
            </button>
          </div>
        </form>
      </div>

      {load && (
        <div className="fixed inset-0 h-screen w-screen flex items-center justify-center bg-black bg-opacity-50">
          <span class="loader"></span>
        </div>
      )}
    </div>
  );
}

export default AddStaffForm;
